function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(1114.028 308.004) rotate(150)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M658.754,495.636a47.8,47.8,0,1,0,47.8,47.8,47.807,47.807,0,0,0-47.8-47.8",
  transform: "translate(175.397 0)",
  fill: "#f6d3d7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M687.422,677.768a90.179,90.179,0,1,0-90.185-90.185,90.185,90.185,0,0,0,90.185,90.185",
  transform: "translate(0.001 22.699)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M641.014,506.568a27.051,27.051,0,1,0,27.052,27.051,27.052,27.052,0,0,0-27.052-27.051",
  transform: "translate(213.888 139.795)",
  fill: "#eb94a0"
}));

function SvgBubbles(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 336.751,
    height: 319.748,
    viewBox: "0 0 336.751 319.748",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBubbles);
export default __webpack_public_path__ + "static/media/bubbles.152fce80.svg";
export { ForwardRef as ReactComponent };